export interface Article {
  id: string;
  title: string;
  category: string;
  date: string;
  readTime: string;
  views: string;
  cover: string;
  summary: string;
  content: string[];
}

export const articleList: Article[] = [
  {
    id: "guoman-2026-banian",
    title: "2026上半年值得追的国漫盘点：口碑与热度双丰收",
    category: "漫评盘点",
    date: "2026-07-28",
    readTime: "8 分钟",
    views: "1.2万",
    cover: "https://readdy.ai/api/search-image?query=A%20collage%20style%20illustration%20of%20popular%20chinese%20manga%20covers%20and%20characters%20arranged%20on%20a%20warm%20paper%20background%20with%20falling%20sakura%20petals%2C%20various%20comic%20posters%20and%20speech%20bubbles%2C%20warm%20coral%20amber%20and%20green%20palette%2C%20editorial%20magazine%20style%2C%20clean%20composition%2C%20high%20detail&width=1200&height=675&seq=article-01&orientation=landscape",
    summary: "从热血冒险到治愈日常，上半年国漫市场涌现了不少现象级作品。这份盘点从口碑、热度与题材三个维度，为你梳理出最值得入坑的作品。",
    content: [
      "上半年国漫市场百花齐放，既有老牌IP持续发力，也有不少新生力量一鸣惊人。我们从口碑评分、读者热度与题材创新三个维度出发，整理出这份值得收藏的作品盘点。",
      "在热血冒险领域，《风起山海》凭借扎实的分镜与极具张力的战斗场景，成为不少读者每周必追的作品。它不靠华丽特效堆砌，而是用扎实的叙事一点点构建起宏大的山海世界。",
      "治愈系则是另一片沃土。《深夜食堂笔记》以温暖的日常与真挚的情感，在完结后依然保持极高的话题度，成为许多读者心中的年度治愈佳作。",
      "如果你偏爱烧脑推理，那么《雾隐侦探社》的每个案件都值得反复品味。它把社会议题巧妙地嵌入推理结构中，让谜题不止于谜题。",
      "整体来看，上半年国漫在题材多样性与制作水准上都有明显提升。无论是追求刺激还是寻求治愈，这份盘点里总有属于你的那一部。",
    ],
  },
  {
    id: "fenjing-jiaoxue",
    title: "从分镜看漫画叙事：一部好作品的秘密藏在格子里",
    category: "创作干货",
    date: "2026-08-06",
    readTime: "10 分钟",
    views: "9800",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20illustration%20showing%20comic%20storyboard%20panels%20with%20sketches%2C%20character%20studies%20and%20arrow%20flow%20lines%20on%20a%20warm%20desk%20with%20pencils%2C%20close%20up%20of%20hands%20drawing%20panels%2C%20warm%20amber%20and%20cream%20tones%2C%20creative%20process%20documentary%20style%2C%20clean%20composition%2C%20detailed&width=1200&height=675&seq=article-02&orientation=landscape",
    summary: "同样的剧情，为什么有的漫画让人欲罢不能，有的却平平无奇？答案往往藏在格与格之间的节奏里。本文拆解分镜的底层逻辑。",
    content: [
      "很多读者在看完一部作品后会说「节奏真好」，却说不清好在哪。其实漫画叙事的秘密，大多藏在分镜之中——那些被精心安排的格子里。",
      "分镜决定了读者阅读时的时间感与情绪曲线。一格内容量的多寡、画格大小的对比、留白的疏密，都在无声地引导读者的目光与呼吸。",
      "优秀的分镜会主动「控制信息」。该给特写时绝不吝啬，该留悬念时果断留白，通过克制的画面换取更强烈的情感冲击。",
      "对创作者而言，分镜不是画画的技术活，而是思考的排练场。在落笔之前想清楚每一格的「任务」，比追求华丽画风更重要。",
      "读懂分镜，你就能真正看懂一部漫画为什么好看。这也是我们持续开设创作干货专栏的初衷——让更多人理解这门视觉叙事的艺术。",
    ],
  },
  {
    id: "gongzuoshi-damo",
    title: "走进漫画工作室：一部作品是如何从零打磨成型的",
    category: "行业观察",
    date: "2026-07-15",
    readTime: "9 分钟",
    views: "7600",
    cover: "https://readdy.ai/api/search-image?query=A%20warm%20documentary%20photo%20style%20illustration%20of%20a%20comic%20studio%20with%20artists%20at%20drawing%20tables%2C%20screens%20showing%20manga%20panels%2C%20storyboards%20on%20walls%20and%20coffee%20cups%2C%20warm%20natural%20window%20light%2C%20coral%20and%20amber%20accents%2C%20creative%20workplace%20atmosphere%2C%20clean%20editorial%20composition%2C%20high%20detail&width=1200&height=675&seq=article-03&orientation=landscape",
    summary: "从一句话梗概到连载更新的作品，中间要经历多少次推倒重来？我们走进一家漫画工作室，还原作品诞生的完整流程。",
    content: [
      "一部漫画从灵感到成稿，远没有看起来那么轻松。在正式开画之前，团队往往已经在会议室里推翻过无数版设定与大纲。",
      "人物设计是最先定型的环节。要让角色「立得住」，除了外形，更重要的是他的动机、弱点和成长弧线。好的角色，连缺点都是精心设计的。",
      "进入连载后，节奏与质量的双重压力开始显现。编辑与画师之间的高频沟通，成了保证作品稳定产出的关键一环。",
      "在这家工作室的墙上，贴满了从初稿到终稿的对比图。每一处看似随意的线条，背后都是反复推敲与调整的痕迹。",
      "正是这些看不见的打磨，才让最终呈现在读者面前的作品，拥有打动人心的力量。致敬每一位默默耕耘的创作者。",
    ],
  },
  {
    id: "xinren-manhuajia",
    title: "新手漫画家入门指南：从零开始到成功签约的完整路线",
    category: "创作干货",
    date: "2026-08-12",
    readTime: "12 分钟",
    views: "1.5万",
    cover: "https://readdy.ai/api/search-image?query=Illustration%20of%20a%20beginner%20artist%20sitting%20at%20a%20desk%20with%20a%20tablet%20and%20sketchbook%20drawing%20manga%20characters%2C%20step%20by%20step%20sketches%20and%20doodles%20around%2C%20warm%20morning%20light%2C%20cream%20and%20green%20accent%20palette%2C%20encouraging%20learning%20mood%2C%20clean%20composition%2C%20detailed&width=1200&height=675&seq=article-04&orientation=landscape",
    summary: "想画漫画却不知从何下手？从基本功练习、短篇试水到投稿签约，这份为新手量身打造的入门指南，帮你避开最常见的坑。",
    content: [
      "很多想入行的小伙伴，第一步不是急着画大长篇，而是先把「手头的基本功」夯实。线条、透视与人体动态，是绕不开的必修课。",
      "在掌握基础之后，最推荐的方式是完成一个短篇。短篇能让你完整走一遍企划、分镜、成稿的流程，成本低、反馈快。",
      "关于投稿，不要一开始就追求大平台的高门槛。先从小型的漫画社区与征稿活动开始，积累读者与编辑的认可，再逐步向正式平台进军。",
      "心态也很关键。创作路上退稿与低谷是常态，重要的是建立稳定的练习节奏，并坚持向读者与同行反馈学习。",
      "签约从来不是终点，而是新的起点。愿每一位热爱漫画的你，都能在这条路上找到属于自己的表达。",
    ],
  },
  {
    id: "meishi-manhua-tuijian",
    title: "治愈系美食漫画推荐：深夜看这些，连空气都是香的",
    category: "漫评盘点",
    date: "2026-08-15",
    readTime: "6 分钟",
    views: "6400",
    cover: "https://readdy.ai/api/search-image?query=Warm%20food%20illustration%20of%20steaming%20bowls%20of%20ramen%20and%20gourmet%20dishes%20surrounded%20by%20cute%20manga%20characters%20enjoying%20meals%2C%20cozy%20kitchen%20background%2C%20warm%20golden%20light%2C%20appetizing%20and%20healing%20mood%2C%20cream%20and%20amber%20palette%2C%20clean%20composition%2C%20high%20detail&width=1200&height=675&seq=article-05&orientation=landscape",
    summary: "忙碌一天后，没有什么比一部美食漫画更能治愈疲惫的心。精选五部治愈系美食佳作，陪你度过每一个安静夜晚。",
    content: [
      "深夜打开一部美食漫画，仿佛隔着屏幕都能闻到食物的香气。今天为你精选五部治愈值拉满的美食佳作，适合窝在被窝里慢慢看。",
      "第一类是「深夜食堂」式的日常治愈。它们不追求复杂的剧情，而是用一顿顿饭的温度，抚平现代人疲惫的内心。",
      "第二类是「美食加成长」的叙事。主角在一次次烹饪挑战中收获自信与友谊，食物成为推动人物成长的温暖媒介。",
      "还有一类主打「食物与回忆」。一道家常菜连接起主角的童年与乡愁，让简单的画面承载厚重的情感。",
      "美食漫画的魅力，在于它总能以最温柔的方式提醒我们：无论生活多忙，都要好好吃饭，好好爱自己。",
    ],
  },
];

export const faqList: { q: string; a: string }[] = [
  {
    q: "樱花漫画是一个什么样的网站？",
    a: "樱花漫画是专注于国产漫画的推荐与资讯平台。我们聚合热门漫画排行、作品分类、新作连载动态与深度专题文章，帮助读者快速发现值得追的漫画作品，了解国漫行业的最新动态。",
  },
  {
    q: "如何快速找到符合我口味的漫画？",
    a: "你可以通过顶部的分类浏览（如热血冒险、治愈美食、恋爱治愈等）筛选作品，也可以在首页查看「热门排行」与「编辑推荐」栏目。每部作品都附有题材标签、评分与简介，方便你快速判断是否对味。",
  },
  {
    q: "这里的漫画作品是完整免费阅读吗？",
    a: "樱花漫画是一个推荐与资讯网站，只提供作品的介绍、评分与阅读指引，不直接提供盗版或破解资源。如需阅读，建议前往作品的正版授权平台，支持你喜爱的创作者。",
  },
  {
    q: "「编辑推荐」和「热门排行」有什么区别？",
    a: "热门排行依据读者的人气数据自动生成，反映的是当下最受关注的趋势；编辑推荐则更多从作品质量、题材价值与独特性出发，由我们的编辑团队精选，更偏重「值得细品」的方向。",
  },
  {
    q: "如何订阅网站的最新内容？",
    a: "你可以在首页底部或联系我们页面填写邮箱，订阅我们的「每周漫讯」邮件。我们会定期为你推送值得关注的新作、专题文章与行业动态，订阅完全免费，随时可以取消。",
  },
  {
    q: "我可以投稿漫画资讯或文章吗？",
    a: "当然可以！我们欢迎漫评、盘点与创作干货类的投稿。你可以通过联系我们页面提交你的稿件，审核通过后会在「资讯」栏目署名发布，优秀作者还有机会成为网站签约专栏作者。",
  },
];